<template>
  <v-toolbar class="main-menu">
    <v-sheet class="mx-auto" max-width="2500" min-width="0" color="primary">
      <v-slide-group multiple show-arrows>
        <MainMenuCategory
          v-for="category of categories"
          :key="category.id"
          :category="category"
          :subcategories="subcategories"
          :languages="languages"
        />
      </v-slide-group>
    </v-sheet>
    <v-toolbar-items> </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import MainMenuCategory from '@/components/MainMenuCategory'
import {
  MENU_CATEGORIES,
  SUBCATEGORIES_MAP,
  LANGUAGES_MAP
} from '@/consts/categories'

export default {
  components: { MainMenuCategory },
  data() {
    return {
      categories: MENU_CATEGORIES,
      subcategories: SUBCATEGORIES_MAP,
      languages: LANGUAGES_MAP
    }
  }
  /*
  firestore: {
    categories: categoriesCol.orderBy('order'),
    subcategories: subcategoriesCol.orderBy('order'),
    languages: languagesCol.orderBy('order')
  }*/
}
</script>

<style lang="scss">
.main-menu.v-toolbar {
  position: sticky;
  top: 0;
  z-index: 1;
  //Vuetify overwrites
  &.theme--light.v-toolbar.v-sheet {
    background-color: #f98306;
  }
  .v-toolbar__content {
    padding: 0;

    .v-slide-group__prev,
    .v-slide-group__next {
      flex: 0 1 45px;
      min-width: 25px;

      @media only screen and (min-width: 985px) {
        display: none;
      }
    }
    .v-slide-group__wrapper {
      overflow-x: auto;
      overflow-y: hidden;
      max-height: 64px;
    }
    .theme--light.v-icon.v-icon {
      background: white;
      border-radius: 50%;
    }
    .theme--light.v-icon.v-icon.v-icon--disabled {
      display: none;
    }
    .v-btn {
      border-radius: 0;
    }
    .v-btn:not(.v-btn--round).v-size--default {
      height: 64px;
      padding: 0 15px;
    }
    .v-slide-group__content .v-btn--contained {
      box-shadow: none;
    }
    .v-list-item {
      padding: 0;
    }
  }
}
.main-menu-v-list.v-list {
  max-width: 258px;
  width: 258px;
  padding: 0;

  .v-list-group {
    > .v-list-item {
      .v-list-item__title {
        font-size: 20px;
        font-weight: bold;
      }
    }
    &.v-list-group--active {
      > .v-list-item {
        background-color: #004891 !important;
        color: white;
      }
    }
    &:nth-child(odd) {
      .v-list-group__header.v-list-item {
        background-color: #dcf1fc;
      }
    }
    &:nth-child(even) {
      .v-list-group__header.v-list-item {
        background-color: #eef9fe;
      }
    }
  }

  .v-list-item:nth-child(odd) {
    background-color: #dcf1fc;
  }
  .v-list-item:nth-child(even) {
    background-color: #eef9fe;
  }
  .main-menu-item.theme--light.v-list-item:not(.v-list-item--disabled) {
    color: #174183 !important;

    .menu-subtitle-1 {
      color: #76767b !important;
      font-size: 12px;
    }
  }

  .main-menu-item {
    .menu-1 {
      align-items: center;
      align-self: center;
      min-height: 15px;

      .menu-title-1 {
        font-size: 22px;
        padding-right: 10px;
        font-weight: 600;
        text-transform: uppercase;

        &.menu-capitalized {
          text-transform: capitalize;
        }
      }
      .menu-triangle {
        border-top: 7px solid transparent;
        border-bottom: 7px solid transparent;
        border-left: 7px solid #ed760a;
        height: 0;
        width: 0;
        padding-right: 5px;
      }
    }
    .menu-2 {
      padding-left: 15px;
      padding-top: 5px;

      .menu-title-2 {
        align-items: center;
        align-self: center;

        .menu-dot {
          height: 6px;
          width: 6px;
          background-color: #e7660a;
          border-radius: 50%;
          display: inline-block;
          margin-right: 6px;
        }
      }
      .menu-subtitle-2 {
        font-size: 14px;
        padding-top: 4px;
      }
    }
  }
}
.main-menu-content {
  border-radius: 0 0 4px 4px;
}
</style>
